package com.anjuros.website.templates.template10.styles

import com.anjuros.website.templates.template10.modules.Template10Theme
import com.varabyte.kobweb.compose.css.StyleVariable
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.rotate
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.translateY
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.deg
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px


val Template10ColorVar by StyleVariable<CSSColorValue>()

/** Vertical (top-to-bottom, right-to-left) text, like a hanging scroll. */
fun Modifier.template10Vertical(): Modifier = this.styleModifier {
    property("writing-mode", "vertical-rl")
}

val Template10ContainerStyle = CssStyle {
    base { Modifier.fillMaxWidth(90.percent).maxWidth(1240.px) }
}

val Template10WideContainerStyle = CssStyle {
    base { Modifier.fillMaxWidth(92.percent).maxWidth(1320.px) }
}

val Template10SectionPaddingStyle = CssStyle {
    base { Modifier.padding(topBottom = 72.px) }
    Breakpoint.MD { Modifier.padding(topBottom = 96.px) }
    Breakpoint.LG { Modifier.padding(topBottom = 112.px) }
}

val Template10HeroStyle = CssStyle {
    base { Modifier.height(720.px) }
    Breakpoint.MD { Modifier.height(800.px) }
    Breakpoint.LG { Modifier.height(900.px) }
}

val Template10InkCircleStyle = CssStyle {
    base { Modifier.size(240.px) }
    Breakpoint.MD { Modifier.size(320.px) }
    Breakpoint.LG { Modifier.size(380.px) }
}

val Template10MottoStyle = CssStyle {
    base { Modifier.fontSize(40.px).lineHeight(1.2) }
    Breakpoint.MD { Modifier.fontSize(52.px).lineHeight(1.2) }
    Breakpoint.LG { Modifier.fontSize(64.px).lineHeight(1.2) }
}

val Template10TaglineStyle = CssStyle {
    base { Modifier.fontSize(24.px).lineHeight(1.3) }
    Breakpoint.MD { Modifier.fontSize(30.px).lineHeight(1.3) }
    Breakpoint.LG { Modifier.fontSize(34.px).lineHeight(1.3) }
}

val Template10TitleStyle = CssStyle {
    base { Modifier.fontSize(34.px).lineHeight(1.12) }
    Breakpoint.MD { Modifier.fontSize(44.px).lineHeight(1.1) }
    Breakpoint.LG { Modifier.fontSize(52.px).lineHeight(1.1) }
}

val Template10QuoteStyle = CssStyle {
    base { Modifier.fontSize(30.px).lineHeight(1.15) }
    Breakpoint.MD { Modifier.fontSize(40.px).lineHeight(1.12) }
    Breakpoint.LG { Modifier.fontSize(48.px).lineHeight(1.12) }
}

val Template10GlyphStyle = CssStyle {
    base { Modifier.fontSize(96.px).lineHeight(1) }
    Breakpoint.LG { Modifier.fontSize(120.px).lineHeight(1) }
}

val Template10WatermarkStyle = CssStyle {
    base { Modifier.fontSize(280.px).lineHeight(1) }
    Breakpoint.LG { Modifier.fontSize(560.px).lineHeight(1) }
}

val Template10AboutImageStyle = CssStyle {
    base { Modifier.height(420.px) }
    Breakpoint.MD { Modifier.height(500.px) }
    Breakpoint.LG { Modifier.height(560.px) }
}

val Template10MenuWidthStyle = CssStyle {
    base { Modifier.width(78.percent) }
    Breakpoint.SM { Modifier.width(55.percent) }
    Breakpoint.MD { Modifier.width(38.percent) }
}

/** The paper "letter" with the contact form – tilted only on wide screens. */
val Template10LetterStyle = CssStyle {
    base { Modifier.rotate(0.deg) }
    Breakpoint.LG { Modifier.rotate((-1.2).deg) }
}

val Template10NavItemStyle = CssStyle {
    base {
        Modifier
            .color(Template10Theme.Paper.rgb)
            .transition(Transition.of(property = "color", duration = 200.ms))
    }
    hover {
        Modifier.color(Template10ColorVar.value())
    }
}

val Template10FooterLinkStyle = CssStyle {
    base {
        Modifier
            .color(Template10Theme.Paper.rgb)
            .transition(Transition.of(property = "color", duration = 200.ms))
    }
    hover {
        Modifier.color(Template10Theme.Coral.rgb)
    }
}

/** Venue tiles in the hero strip – subtle lift of the background on hover. */
val Template10VenueTileStyle = CssStyle {
    base {
        Modifier
            .backgroundColor(Template10Theme.StripOverlay.rgb)
            .transition(Transition.of(property = "background-color", duration = 250.ms))
    }
    hover {
        Modifier.backgroundColor(Template10Theme.InkCard.rgb)
    }
}

val Template10CardHoverStyle = CssStyle {
    base {
        Modifier
            .translateY(0.px)
            .transition(Transition.of(property = "translate", duration = 300.ms))
    }
    hover {
        Modifier.translateY((-6).px)
    }
}
